import classNames from 'classnames';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import MasterLogo from './MasterLogo';

export default function MasterLink({}) {
  const { t } = useTranslation();

  return (
    // TODO: when master chat will be implemented uncomment this line and remove the next one
    // <Link href={UIPaths.masterConversation()} >
    <Link href='/'>
      <div className={classNames('flex flex-row items-center justify-start')}>
        <div className='pr-md'>
          <MasterLogo size={32} />
        </div>
      </div>
    </Link>
  );
}
